<template>

    <div>

        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', 'orders-and-menu') ">

            Back
        </button>
        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', null ) ">

            <font-awesome-icon icon="list-ol" size="3x" />
            all orders
        </button>
        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', null ) ">

            <font-awesome-icon icon="heartbeat" size="3x" />
            business health
        </button>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'orders-options',
        methods: {

        },
        components: {

            FontAwesomeIcon
        }
    }

</script>

<style scoped>

</style>